module.exports = __webpack_public_path__ + "img/code.0452fd4a.png";